@use '../../../../../styles/Constants.scss' as Constants;

.attachmentTable {
	margin-bottom: Constants.$val-spacing-m;
}

.cell {
	display: block;
	text-overflow: ellipsis;
	overflow:hidden;
	white-space:nowrap;
	user-select: text;
}